import { bool, func, object } from "prop-types";
import React, { useState } from "react";
import Filters from "../Filters/Filters";
import FilterGroup from "./FilterGroup";
import Loading from "../../UI/Loading/Loading";
import useConditionalFilters from "../../hooks/useConditionalFilters";
import Flex from "../../UI/Flex/Flex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";

function MenuFilter({
  filterType,
  select,
  open,
  menuFilterShortList,
  dataSourceAccessConfig,
  additionalTheme,
  comparisonModeItem,
  selectPowerEditorModeFilter,
  searchFilterLoading,
  loadValues,
  selectedValues,
  currentTabId,
  error,
  isSingleQueryFilter,
  domain,
}) {
  useConditionalFilters(filterType);
  const [searchValue, setSearchValue] = useState("");
  const [likeEnabled, setLikeEnabled] = useState(false);

  return (
    <FilterGroup
      name={filterType.displayName}
      open={open}
      cy="left-menu-filter-group"
      filter={filterType}
      select={select}
      additionalTheme={additionalTheme}
      loadValues={loadValues}
      selectedValues={selectedValues}
      isSingleQueryFilter={isSingleQueryFilter}
    >
      {filterType.values ? (
        <Filters
          filterType={filterType}
          select={select}
          menuFilterShortList={menuFilterShortList}
          dataSourceAccessConfig={dataSourceAccessConfig}
          comparisonModeItem={comparisonModeItem}
          selectPowerEditorModeFilter={selectPowerEditorModeFilter}
          additionalTheme={additionalTheme}
          searchFilterLoading={searchFilterLoading}
          selectedValues={selectedValues}
          loadValues={loadValues}
          currentTabId={currentTabId}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          likeEnabled={likeEnabled}
          setLikeEnabled={setLikeEnabled}
          domain={domain}
        />
      ) : error ? (
        <div>
          <FontAwesomeIcon icon={faExclamationCircle} /> {error.message}
        </div>
      ) : (
        <Flex mb2>
          <Loading />
        </Flex>
      )}
    </FilterGroup>
  );
}

MenuFilter.propTypes = {
  filterType: object.isRequired,
  select: func.isRequired,
  open: bool,
};

export default React.memo(MenuFilter);
